<template>
    <div>
        <main class="authentication">
            <div class="authentication__content">
                <div class="authentication__form authentication__form--login">
                    <h1 class="authentication__form-title">{{ trans('page.password-set.title') }}</h1>
                    <password-set :token="token" :email="email" @submit="setPassword" />
                </div>
            </div>
        </main>
    </div>
</template>

<script>
import { apiMixin } from 'relapp-api';
import { pageLoadingStatusMixin } from 'relapp-loading';
import { mapGetters } from 'vuex';
import { PasswordSet, AuthApi } from 'relapp-auth';
import { EventBus } from 'relapp-event';

export default {
    components: {
        PasswordSet
    },
    mixins: [apiMixin, pageLoadingStatusMixin],

    props: {
        token: {
            type: String,
            required: false
        },
        email: {
            type: String,
            required: false
        }
    },
    /**
     * Called after the instance has been mounted.
     */
    mounted() {
        this.finishLoading();
        if (this.isLoggedIn) {
            this.$router.push({ name: 'home' });
        }
    },
    computed: {
        ...mapGetters({
            isLoggedIn: 'user/isLoggedIn'
        })
    },
    methods: {
        /**
         * Call the endpoint to set the password.
         *
         * @param {object} form
         */
        setPassword(form) {
            this.startLoading();
            AuthApi.setPassword(form)
                .then(() => {
                    this.finishLoading();
                    this.$router.push({ name: 'login' });

                    EventBus.$emit('notification', {
                        type: 'success',
                        message: trans('authentication.password-set.confirmation.message')
                    });
                })
                .catch(this.handleError)
                .then(this.finishLoading);
        }
    },
    metaInfo: {
        title: trans('page.password-set.title')
    }
};
</script>
